module.exports = "/_next/static/images/GeneralS-40ddc07573dec5a29d56e3af89e93be3.svg";